
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";

export function ContactManualAdd({ onClick }: { onClick?: () => void }) {
  return (
    <Button onClick={onClick} variant="linear-light" className="rounded-full h-8 sm:h-5.5" size="xs">
      <Icon name="IconPlusSmall" size={16} className="size-4" />
      Manually Add Contact
    </Button>
  );
}
